import React from 'react';

import { Page } from '../../../../../shared/ui/Page';
import { LegalInfo } from '../containers/LegalInfo';

export const LegalPage = () => {
    return (
        <Page isBackButton title={'Юридические данные'}>
            <LegalInfo />
        </Page>
    );
};
